export const EVENTS = {
    SAVE_EDIT: 'editsave',
    START_EDIT: 'editstart',
    CANCEL_EDIT: 'editcancel',
};

export const PLACEHOLDERS = {
    LABEL: '[label]',
};

export const DEFAULT_LABEL_FORMAT = PLACEHOLDERS.LABEL + ':';
